












































































































































































































































































































































































import mixins from 'vue-typed-mixins';
import RandomMixin from '@/mixins/SmartTable/RandomMixin';
import JQueryMixin from '@/mixins/SmartTable/JQueryMixin';
import { Filter } from '@/models/SmartTable/Filter';
import { State } from '@/models/SmartTable/State';
import { Column } from '@/models/SmartTable/Column';
import { Sorting } from '@/models/SmartTable/Sorting';
import { SortMode } from '@/models/SmartTable/SortMode';
import { ITranslation } from '@/models/SmartTable/ITranslation';
import { FilterExpressionType } from '@/models/SmartTable/FilterExpressionType';
import { FilterSpecification } from '@/models/SmartTable/FilterSpecification';
import { FieldType, isTimeBasedFieldType } from '@/models/SmartTable/FieldType';
import {
  dateTimeValueFromInputEvent as dateTimeValueFromInputEventInternal,
  displayValueForDateTimeInput as displayValueForDateTimeInputInternal
} from '@/models/SmartTable/DateTimeInput';

export default mixins(JQueryMixin, RandomMixin).extend({
  props: {
    column: Object as () => Column,
    state: Object as () => State,
    hiddenColumns: Array as () => Array<Column>,
    translation: Object as () => ITranslation,
    tableId: { type: String, default: 'smartTableTable' },
    localIdentifier: Number,
    defaultFilterSpecification: { type: String, default: 'equals' },
    defaultBooleanFilterSpecification: { type: String, default: 'true' },
    defaultDateFilterSpecification: { type: String, default: 'between' },
    defaultDateTimeFilterSpecification: { type: String, default: 'between' }
  },
  data: function () {
    return {
      filterSpecification: '' as FilterSpecification,
      filterInput: [] as FilterExpressionType[],
      filterInputOther: [] as FilterExpressionType[],
      newFilterInput: '',
      newFilterInputOther: '',
      showHiddenColumns: false
    };
  },
  created: function () {
    this.filterSpecification = this.defaultFilterSpecification as FilterSpecification;
    if (this.column.fieldType === 'boolean') {
      this.filterSpecification = this.defaultBooleanFilterSpecification as FilterSpecification;
    }
    if (this.column.fieldType === 'date') {
      this.filterSpecification = this.defaultDateFilterSpecification as FilterSpecification;
    }
    if (this.column.fieldType === 'datetime-local') {
      this.filterSpecification = this.defaultDateTimeFilterSpecification as FilterSpecification;
    }
  },
  mounted: function () {
    this.jquery()(
      `#${this.tableId}HeadMenuDropdown-${this.column.fieldName}-${this.localIdentifier}.dropdown`
    ).on(
      'shown.bs.dropdown',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      function (event: Event) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        // @ts-ignore
        this.$nextTick(() => {
          that.filterInput = (that.filter || { filterQuery: [] }).filterQuery.slice();
          that.filterInputOther = [];
          if (that.column.fieldType === 'date' || that.column.fieldType === 'datetime-local') {
            for (let index = 0; index < that.filterInput.length; index++) {
              const data = ('' + that.filterInput[index]).split(',');
              if (data.length == 2) {
                that.filterInput[index] = data[0];
                that.filterInputOther.push(data[1]);
              }
            }
          }
          that.jquery()('.dropdown.show input').select().focus();
        });
      }.bind(this)
    );
  },
  computed: {
    hasFilter: function () {
      // @ts-ignore
      return !!this.filter;
    },
    filter: {
      get: function (): Filter | undefined {
        return this.state.filters.find((f) => f.fieldName === this.column.fieldName);
      },
      set: function (filter: Filter): void {
        if (!filter) {
          this.state.filters = this.state.filters.filter(
            (f) => f.fieldName !== this.column.fieldName
          );
          return;
        }

        let oldFilter = this.state.filters.find((f) => f.fieldName === this.column.fieldName);
        if (!oldFilter) {
          this.state.filters.push(filter);
        }
      }
    }
  },
  watch: {
    filterSpecification: function () {
      this.filterInput = [];
      this.filterInputOther = [];
    }
  },
  methods: {
    moveColumn: function (direction: 'left' | 'right') {
      const offset = direction === 'left' ? -1 : 1;
      this.$emit('move-column', { column: this.column, offset: offset });
    },
    showColumn: function (column: Column) {
      column.hidden = false;
      this.toggleDropdown();
      this.$emit('update:column', column);
    },
    hideColumn: function () {
      this.column.hidden = true;
      this.toggleDropdown();
      this.$emit('update:column', this.column);
    },
    changeSorting: function (sortMode: SortMode, addToSort: boolean) {
      let sorting: Sorting[] = [];
      if (addToSort) {
        sorting = this.state.sorting.filter((s) => s.sortBy !== this.column.fieldName);
      }
      sorting.push(new Sorting(this.column.fieldName, sortMode));
      const state = new State(sorting, this.state.filters);
      this.toggleDropdown();
      this.$emit('update:state', state);
      this.layoutChanged();
    },
    layoutChanged() {
      this.$emit('layout-changed');
    },
    removeFilter: function () {
      this.filter = undefined;
      this.filterInput = [];
      this.toggleDropdown();
      this.$emit('update:state', this.state);
      this.layoutChanged();
    },
    changeFilter: function () {
      if (this.newFilterInput !== undefined && this.newFilterInput !== '') {
        switch (this.column.fieldType) {
          case 'numeric':
          case 'string':
          case 'boolean':
          case 'dropdown':
            this.filterInput.push(this.newFilterInput);
            break;
          case 'date':
          case 'datetime-local':
            this.filterInput.push(this.newFilterInput);
            this.filterInputOther.push(this.newFilterInputOther);
            break;
        }

        this.newFilterInput = '';
        this.newFilterInputOther = '';
      }

      this.updateFilterFromSpecification();
      this.toggleDropdown();
      this.$emit('update:state', this.state);
      this.layoutChanged();
    },
    updateFilterFromSpecification: function () {
      if (
        this.filterSpecification === 'empty' ||
        this.filterSpecification === 'notempty' ||
        this.filterSpecification === 'true' ||
        this.filterSpecification === 'false' ||
        (this.filterInput && this.filterInput.length > 0)
      ) {
        if (!this.filter) {
          this.filter = new Filter(this.column.fieldName, this.column.fieldType, 'equals', []);
        }

        switch (this.filterSpecification) {
          case 'contains':
          case 'equals':
          case 'notequals':
          case 'before':
          case 'after':
            this.filter.filterType = this.filterSpecification;
            this.filter.filterQuery = [];
            for (const input of this.filterInput) {
              this.filter.filterQuery = this.filter.filterQuery.concat(
                this.column.filterConverter(input)
              );
            }
            break;
          case 'between':
            this.filter.filterType = 'between';
            this.filter.filterQuery = [];
            for (const [index, input] of this.filterInput.entries()) {
              this.filter.filterQuery = this.filter.filterQuery.concat(
                this.column.filterConverter(input) +
                  ',' +
                  this.column.filterConverter(this.filterInputOther[index])
              );
            }
            break;
          case 'empty':
            this.filter.filterType = 'equals';
            this.filter.filterQuery = [''];
            break;
          case 'notempty':
            this.filter.filterType = 'notequals';
            this.filter.filterQuery = [''];
            break;
          case 'true':
            this.filter.filterType = 'equals';
            this.filter.filterQuery = [true];
            break;
          case 'false':
            this.filter.filterType = 'equals';
            this.filter.filterQuery = [false];
            break;
        }
      } else {
        this.filter = undefined;
      }
    },
    toggleDropdown: function () {
      this.showHiddenColumns = false;
      this.jquery()(
        `#${this.tableId}HeadMenuDropdownToggle-${this.column.fieldName}-${this.localIdentifier}`
      ).click();
    },
    isTimeBasedFilter(fieldType: FieldType) {
      return isTimeBasedFieldType(fieldType);
    },
    dateTimeValueFromInputEvent(inputEvent: Event): string | null {
      return dateTimeValueFromInputEventInternal(inputEvent);
    },
    displayValueForDateTimeInput(dateTimeValue: Date | null): string {
      return displayValueForDateTimeInputInternal(dateTimeValue);
    }
  }
});
